"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var ExpandMore_1 = require("@material-ui/icons/ExpandMore");
var sectionExtenderStyles_1 = require("./sectionExtenderStyles");
var clsx_1 = require("clsx");
var SectionExtender = function (_a) {
    var text = _a.text, onClick = _a.onClick, isSectionExtended = _a.isSectionExtended;
    var style = sectionExtenderStyles_1.default();
    return (<core_1.Box className={clsx_1.default(style.sectionExtenderWrapper)} onClick={onClick} data-test="summary:container:section_extender">
      <core_1.Box className={style.iconContainer}>
        <core_1.Box className={style.text}>{text}</core_1.Box>
        <ExpandMore_1.default className={clsx_1.default([style.icon, isSectionExtended && style.rotatedArrow])}/>
      </core_1.Box>
    </core_1.Box>);
};
exports.default = SectionExtender;
